"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _jsxRuntime = require("@emotion/react/jsx-runtime");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var SvgUser = function SvgUser(_ref) {
  var fill = _ref.fill,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["fill", "title"]);

  return (0, _jsxRuntime.jsxs)("svg", _objectSpread(_objectSpread({
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), {}, {
    children: [title ? (0, _jsxRuntime.jsx)("title", {
      children: title
    }) : null, (0, _jsxRuntime.jsx)("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M12.0001 2C8.13413 2 5.00012 5.13401 5.00012 9C5.00012 11.3287 6.13727 13.3919 7.88658 14.6644C5.26744 15.5375 3.01931 17.2212 1.44043 19.416L3.06398 20.584C5.06252 17.8058 8.32042 16 12.0001 16C15.6798 16 18.9377 17.8058 20.9362 20.584L22.5598 19.416C20.9809 17.2212 18.7328 15.5375 16.1137 14.6644C17.863 13.3919 19.0001 11.3287 19.0001 9C19.0001 5.13401 15.8661 2 12.0001 2ZM7.00012 9C7.00012 6.23858 9.2387 4 12.0001 4C14.7615 4 17.0001 6.23858 17.0001 9C17.0001 11.7614 14.7615 14 12.0001 14C9.2387 14 7.00012 11.7614 7.00012 9Z",
      fill: fill
    })]
  }));
};

var _default = SvgUser;
exports["default"] = _default;